import {createBrowserHistory} from 'history'
import {createReduxHistoryContext} from 'redux-first-history'

const browserHistory = createBrowserHistory()

const {createReduxHistory, routerMiddleware, routerReducer} = createReduxHistoryContext({
    history: browserHistory,
    // if > 0 add the key "previousLocation" to state.router, with the last N locations
    // savePreviousLocations: 1,
})

export {createReduxHistory, routerMiddleware, routerReducer}
